import { h, Host } from "@stencil/core";
import api from "../../utils/api";
import { getAttributesCamelCase } from "../../utils/getAttributesCamelCase";
import { filterObject } from "../../utils/filterObject";
/** these common HTML attributes will not be considered for fetching data */
const ignoreAttributeList = ["class", "id", "style", "slot", "tabindex", "title"];
export class DataIngest {
    /** Is fired when a request is sent with the name of the property */
    startRequest;
    host;
    /** contains the filtered attributes with their URLs */
    attributes = {};
    /** observes changes to the attributes */
    observer;
    componentWillLoad() {
        this.refreshAttributes();
        this.observer = new MutationObserver(() => this.refreshAttributes());
        this.observer.observe(this.host, {
            attributes: true,
            childList: false,
            subtree: false
        });
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    /** reads the attributes and their URLs and matches them with the previous ones */
    refreshAttributes() {
        const oldAttributes = this.attributes;
        this.attributes = filterObject(getAttributesCamelCase(this.host), ignoreAttributeList);
        Object.keys(this.attributes).forEach((key) => {
            // @ts-expect-error Check for typing
            if (this.attributes[key] !== oldAttributes[key]) {
                this.loadData(key);
            }
        });
    }
    /** loads the data from the url supplied via attribute to put it onto the child element */
    loadData(attributeName) {
        // @ts-expect-error Check for typing
        const url = this.attributes[attributeName];
        if (url === "") {
            return;
        }
        if (url.charAt(0) === "#") {
            return this.getScriptTag(attributeName);
        }
        this.startRequest.emit(attributeName);
        const child = this.host.firstElementChild;
        const loading = `${attributeName}Loading`;
        if (child === null) {
            return;
        }
        // @ts-expect-error Check for typing
        child[loading] = true;
        api(url)
            .then((result) => {
            // @ts-expect-error Check for typing
            child[loading] = false;
            // @ts-expect-error Check for typing
            child[attributeName] = result;
        })
            .catch(() => {
            // @ts-expect-error Check for typing
            child[loading] = false;
        });
    }
    getScriptTag(attributeName) {
        // @ts-expect-error Check for typing
        const url = this.attributes[attributeName] || "";
        // we decided to use data-id instead of id because it can not always be ensured that the id is unique.
        // @ts-expect-error Check for typing
        const tag = this.host.querySelector(`[data-id="${url.replace("#", "")}"]`);
        if (!tag) {
            return;
        }
        if (url.length < 2 || tag === null) {
            return;
        }
        const content = tag.innerHTML;
        let result;
        if (tag.type === "application/json") {
            result = JSON.parse(content);
        }
        if (tag.type === "text/plain") {
            result = String(content).trim();
        }
        const child = this.host.firstElementChild;
        if (child === null) {
            return;
        }
        // @ts-expect-error Check for typing
        child[attributeName] = result;
    }
    render() {
        return (h(Host, { key: 'a2a97ad41d9eeb85b333982a0a8617f9d4ca04e4', class: "ux-data-ingest" }, h("slot", { key: '16beb0885e5b3283157f3f7996ba9dae119c83d5' })));
    }
    static get is() { return "ux-data-ingest"; }
    static get originalStyleUrls() {
        return {
            "$": ["data-ingest.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["data-ingest.css"]
        };
    }
    static get events() {
        return [{
                "method": "startRequest",
                "name": "uxStartRequest",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Is fired when a request is sent with the name of the property"
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=data-ingest.js.map
